import { RequestStatus } from "mobx-store";
import Connections from "../../connections";
import { action, observable } from "mobx";

export class UserDeletionRequestStore {
  @observable status: RequestStatus = RequestStatus.IDLE;
  @observable error: string = "Something went wrong";

  @action.bound
  public async createUserDeletionRequest(
    membershipId: string,
    phoneNumber: string
  ): Promise<void> {
    try {
      this.status = RequestStatus.LOADING;
      await Connections.wadiDeglaAxios.httpPost("/users-deletion-requests", {
        membershipId,
        phoneNumber,
      });
      this.status = RequestStatus.SUCCESS;
    } catch (error) {
      const message = (error as any)?.response?.data?.message;
      if (message) this.error = message;
      this.status = RequestStatus.FAILED;
    }
  }
}
